<template>
  <show-page
    :aspect-menu-items="aspectMenuItems"
    :errors="errors"
    :log-entries="model.logEntries"
    :meta="meta"
    :model="model"
    :toasts="toasts"
  >
  </show-page>
</template>

<script>
import ShowPage from '@/structures/default/Pages/Models/Show';

export default {
  components: {
    ShowPage,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
